<!-- ######################################################################
#
# Superuser Form
#
###################################################################### -->

<template>
<div>
  <base-header class="pb-6" />
  <b-container fluid class="mt--6 max-width">
    <b-card no-body>

      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <b-form id="entity_form" role="form" @submit.prevent="handleSubmit(onSubmit)">

          <card-header title="Create Account">
            <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
            <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Create</base-button>
          </card-header>

          <b-card-body>
            <b-row>
              <b-col md="6">
                <base-input label="Username" name="name"
                            v-model="model.name"
                            :rules="{required: true, apiname: true}" />
              </b-col>
              <b-col md="6">
                <base-input label="E-mail" placeholder="" name="E-mail" v-model="model.email" :rules="{required: true, email: true}"/>
              </b-col>
            </b-row>

            <!-- password fields ####################################################### -->
            <b-row>
              <b-col md="6">
                <base-input label="Password"
                            placeholder=""
                            name="password"
                            v-model="model.password"
                            ref="password"
                            type="password" autocomplete="on"
                            :rules="{required: true, min: 6}" />
              </b-col>
              <b-col md="6">
                <base-input label="Password Confirmation"
                            placeholder=""
                            name="passwordConfirm"
                            v-model="passwordConfirmation"
                            type="password" autocomplete="on"
                            :rules="{required: true, confirmed:'password' }" />
              </b-col>
            </b-row>

            <!-- account type + entity ####################################################### -->
            <b-row>
              <b-col md="6" class="mb-3">
                <label class="form-control-label">Account Type</label>
                <b-form-select
                    class="form-control"
                    v-model="model.subtype"
                    :options="accountTypes" />
              </b-col>
              <b-col md="6" v-if="model.subtype!=='sadmin'">
                <label class="form-control-label">Entity</label>
                <b-form-select
                    class="form-control"
                    v-model="model.entity"
                    :rules="{required: model.subtype !== 'sadmin' }"
                    :options="entitiesData" />
              </b-col>
            </b-row>

            <!-- access control ####################################################### -->
            <b-row >
              <b-col  md="12">
                <label  class="form-control-label">Access Permissions</label>
                <div class="mt-2">
                  <!-- All Access Option -->
                  <b-form-checkbox
                      v-model="accessAll"
                      @change="onAccessAllChange"
                      class="mb-2">
                    <strong>All Access</strong> - Full system access
                  </b-form-checkbox>
                  
                  <!-- Individual Permission Options -->
                  <div class="ml-3">
                    <b-form-checkbox-group
                        v-model="selectedAccess"
                        :options="accessOptions"
                        :disabled="accessAll"
                        @change="onAccessChange"
                        stacked
                        class="mt-2">
                    </b-form-checkbox-group>
                  </div>
                </div>
                
                <!-- Debug info (remove in production) -->
                <small class="text-muted mt-2 d-block">
                  Current access: {{ JSON.stringify(model.access) }}
                </small>
              </b-col>
            </b-row>

          </b-card-body>

        </b-form>
      </validation-observer>

    </b-card>
  </b-container>
</div>
</template>

<!-- ###################################################################### -->

<script>
import CardHeader from "@/views/components/CardHeader";
import {mapGetters, mapState} from "vuex";
import {Action} from "@/store/actions";
import {Routes} from "@/router";
import AccountService from "@/services/account.service";

export default {
  name: "SAccountNew",
  // ----------
  data() {
    return {
      passwordConfirmation: '',
      model: {
        name: '',
        email: '',
        password: '',
        subtype: 'admin',
        entity: '',
        access: []
      },
      accountTypes: AccountService.typesForDropdown(true),
      entitiesData: [],
      accessAll: false,
      selectedAccess: [],
      accessOptions: [
        { value: 'Dataview_read', text: 'Read - Dataview' },
        { value: 'Dataview_all', text: 'All Access - Dataview' },
        { value: 'Site_read', text: 'Read - Site' },
        { value: 'Site_all', text: 'All Access - Site' },
        { value: 'Group_read', text: 'Read - Group' },
        { value: 'Group_all', text: 'All Access - Group' },
      ]
    };
  },
  // ----------
  components: {
    CardHeader,
  },
  // ----------
  methods: {
    onCancel() { this.$router.back() },
    onSubmit() {
     //console.log(this.model.access)
      this.$store.dispatch(Action.landlord.newAccount, this.model)
          .then(() => { this.$router.push({name: Routes.saccountList}) })
          .catch(error => { console.error(error) })
    },
    onAccessAllChange(checked) {
      if (checked) {
        // When "All" is selected, clear individual selections and set access to ["all"]
        this.selectedAccess = [];
        this.model.access = ["all"];
      } else {
        // When "All" is unchecked, reset to empty array
        this.model.access = [];
      }
    },
    onAccessChange(selectedValues) {
      if (selectedValues.length > 0) {
        // If individual permissions are selected, ensure "All" is unchecked
        this.accessAll = false;
        this.model.access = [...selectedValues];
      } else {
        // If no individual permissions selected, clear access array
        this.model.access = [];
      }
    },
    loadEntities() {
     //console.log("[Vuex] Dispatching llEntitiesLoad");
      console.group('[Component] loadEntities()');
     //console.log('Vuex store state:', this.$store.state);
     //console.log('Landlord module state:', this.$store.state.landlord);
     //console.log('Current entities:', this.entities);
      if (this.entities.length === 0) {
        this.$store.dispatch(Action.landlord.loadEntities)
            .then(() => { this.fillEntitiesData() })
            .catch(error => { console.error(error) })
      } else {
        this.fillEntitiesData();
      }
    },
    fillEntitiesData() {
     //console.log("[Component] Filling entitiesData");
      this.entitiesData = []
      this.entities.forEach((entry) => {
        this.entitiesData.push({ value: entry.name, text: entry.name + " - " + entry.description })
      })
     //console.log("Processed entitiesData:", this.entitiesData);
      if (this.entitiesData.length > 0) {
        this.model.entity = this.entities[0].name
      }
    }
  },
  // ----------
  computed: {
    ...mapState({
      isLoading: state => state.general.loading,
      entities: state => state.landlord.entities
    }),
    ...mapGetters(['saccountByName']),
  },
  // ----------
  watch: {
    // Watch for external changes to model.access (e.g., when editing existing user)
    'model.access': {
      handler(newAccess) {
        if (newAccess && newAccess.includes('all')) {
          this.accessAll = true;
          this.selectedAccess = [];
        } else if (newAccess && Array.isArray(newAccess)) {
          this.accessAll = false;
          this.selectedAccess = [...newAccess];
        }
      },
      immediate: true
    }
  },
  // ---------
  mounted() {
    this.loadEntities()
  }
}
</script>

<style scoped>
/* Optional: Style for disabled checkboxes */
.form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
  color: #6c757d;
}

.form-check:has(.form-check-input:disabled) {
  opacity: 0.6;
}
</style>